import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function TestSelectionPage() {
  const navigate = useNavigate();
  const soundDone = localStorage.getItem('emotionSurveySoundTestCompleted') === 'true';
  const silentDone = localStorage.getItem('emotionSurveySilentTestCompleted') === 'true';
  const hasAnyCompleted = soundDone || silentDone;

  useEffect(() => {
    if (hasAnyCompleted) {
      navigate('/all-tests-complete', { replace: true });
    }
  }, [hasAnyCompleted, navigate]);

  const startSoundTest = () => {
    localStorage.setItem('emotionSurveyCurrentTestMode', 'sound');
    navigate('/task-sound');
  };

  const startSilentTest = () => {
    localStorage.setItem('emotionSurveyCurrentTestMode', 'silent');
    navigate('/task-silent');
  };

  return (
    <div className="page-container test-selection-page">
      <h2>Выберите тип теста</h2>
	  {hasAnyCompleted ? (
        <p>Вы уже завершили необходимый тест. Перенаправляем на финальную страницу...</p>
      ) : (
        <div className="navigation-buttons">
          <button onClick={startSilentTest}>Тест 1: без звука</button>
          <button onClick={startSoundTest}>Тест 2: со звуком</button>
        </div>
      )}
    </div>
  );
}

export default TestSelectionPage;